module.exports = __webpack_public_path__ + "static/img/introduce.f2d4a11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/introduce.jpg
// module id = Lx65
// module chunks = 1